import { combineReducers } from 'redux';

import configReducer from './services/config/reducer';
import UserReducer from './services/user/reducer';
import LoginFeedBackReducer from './scenes/LoginPage/services/loginFeedback/reducer';

const rootReducer = combineReducers({
	config: configReducer,
	user: UserReducer,
	loginFeedback: LoginFeedBackReducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers.js